<template>
  <div class="howToApply" v-if="itemData">

    <div class="ttl noto-semibold" v-if="_.get(itemData, 'useHeader') == 1">
      {{ _.get(itemData, "header.title") }}
    </div>
    <div class="descr" v-if="_.get(itemData, 'header')">
      {{ _.get(itemData, "header.teaser") }}
    </div>

    <div class="howToApplyInner">

      <template v-for="(item, index) in _.get($store.state.indx, 'menu_tools')" v-if="_.get(itemData, index) && _.get(itemData, index)!=0">
        <CalculatorLoans v-if="item.title == 'loan_calculator'" :calcType="_.get(itemData, index)" />
        <CalculatorDeposit v-else-if="item.title == 'deposit_calculator'" :calcType="_.get(itemData, index)" />
        <CalculatorStock v-else-if="item.title == 'stock_calculator'" :calcType="_.get(itemData, index)" />
        <CalculatorMortgage v-else-if="item.title == 'mortgage_calculator'" :calcType="_.get(itemData, index)" />

          <a v-else :href="_.get(item, 'button.url')" :key="index" @click="$store.commit('setStateDeep', { key: 'loader.'+item.title, val: _.get(itemData, index), })" class="usefullTool" :class="_.get(item, 'button.cssclass')" >
            <div class="inner">
              <span v-if="_.get(item, 'button.svg')" v-html="_.get(item, 'button.svg')"></span>
              <div class="ttl noto-semibold">{{ $fn.tr(_.get(item, 'button.title')) }}</div>
            </div>
            <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5.844"
                    height="9.566"
                    viewBox="0 0 5.844 9.566"
            >
              <g
                      id="Group_1006"
                      data-name="Group 1006"
                      transform="translate(42.561 -19638.994) rotate(-90)"
              >
                <path
                        id="Path_61"
                        data-name="Path 61"
                        d="M0,3.722,3.722,0"
                        transform="translate(-19643.777 -41.5)"
                        fill="none"
                        stroke="#444958"
                        stroke-linecap="round"
                        stroke-width="1.5"
                />
                <path
                        id="Path_60"
                        data-name="Path 60"
                        d="M3.722,3.722,0,0"
                        transform="translate(-19647.5 -41.5)"
                        fill="none"
                        stroke="#444958"
                        stroke-linecap="round"
                        stroke-width="1.5"
                />
              </g>
            </svg>
          </a>

      </template>

      <CompareProducts v-if="itemData.compare_products == 1" />
    </div>
  </div>
</template>

<script>
import CalculatorLoans from "@/components/CalculatorLoans";
import CalculatorDeposit from "@/components/CalculatorDeposit";
import CalculatorStock from "@/components/CalculatorStock";
import CalculatorMortgage from "@/components/CalculatorMortgage";
import CompareProducts from "@/components/CompareProducts";

export default {
  data() {
    return {};
  },
  props: {
    itemData: {
      type: Object,
      require: true,
    },
  },
  components: {
    CalculatorLoans,
    CalculatorDeposit,
    CalculatorStock,
    CalculatorMortgage,
    CompareProducts,
  },
  mounted() {
    this.$fn.openChat();
    // this.openChat();
  },
  computed: {
    getUsefulTools() {
      return this.$store.getters.getUsefulTools;
    },
  },
  methods:{

    openChat(){
      var elements = document.getElementsByClassName("openZohoChat");

      for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', function (e) {

          let event = new CustomEvent("open_chat");
          document.dispatchEvent(event);

        }, false);
      }
    },


  }
};
</script>
